var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unlayer-container"},[(!_vm.unlayerError)?_c('div',{staticClass:"unlayer-editor",attrs:{"id":"unlayer-editor"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }